import React from 'react';

const Footer = () => {
    return (
        <>
            <footer class="bg-light p-3">
                <h5 className="text-center font-weight-bold  m-0 " style={{ color: '#004aad' }}>Made with ❤️ By DevSessions</h5>
            </footer>
        </>
    );
};

export default Footer;
